import { ApiResponse, AssociationModel } from "../types";
import { IAssociationFormData, IAssociationFormResponse } from "../association-details";
import { getApiBaseUrl } from "../utils";
import { api } from "../api";

const UPDATE_ASSOCIATION_API_URL = `${getApiBaseUrl()}/api/v1/association`;

export const putAssociationById = async (
  id: string,
  data: IAssociationFormData
): Promise<ApiResponse<AssociationModel>> => {
  const form = new FormData();
  Object.entries(data).forEach(([key, value]) => {
    if (key === "is_non_profit") {
      value = value ? 1 : 0;
    }
    form.append(key, value as string | File);
  });
  form.append("_method", "patch");

  return await api<IAssociationFormResponse>(`${UPDATE_ASSOCIATION_API_URL}/${id}`, {
    method: "POST",
    headers: {
      Accept: "application/json",
    },
    credentials: "include",
    body: form,
  });
};
